import { HaftpflichtSchadenWithAufstellung } from '@gsm/entities';
import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { BaseHaftpflichtSchadenModel, BaseHaftpflichtSchadenModelConfig, HaftpflichtAdditional } from '../shared-models/haftpflichtschaden.model';

export const TYPE_HAFTPFLICHT_PERSONENSCHADEN = 'HAFTPFLICHT-PERSONENSCHADEN';

export interface HaftpflichtPersonenschadenAdditional extends HaftpflichtAdditional {
  vermoegensschaden?: boolean;
}

export interface HaftpflichtPersonenschadenModelConfig extends BaseHaftpflichtSchadenModelConfig<HaftpflichtSchadenWithAufstellung> {
  additional: HaftpflichtPersonenschadenAdditional;
}

export class HaftpflichtPersonenschadenModel extends BaseHaftpflichtSchadenModel<HaftpflichtSchadenWithAufstellung> {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_PERSONENSCHADEN;
  @serializable() additional: HaftpflichtPersonenschadenAdditional;

  constructor(config: HaftpflichtPersonenschadenModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
    // additional is set from super()
  }
}
